/**
 * Trạng thái giấy đề nghị chi FPT
 */
export default {
  Completed: 1, // Hoàn thành
  Issued: 2, // Đã lập
};
